import { render, staticRenderFns } from "./NewUpdateLog.vue?vue&type=template&id=2d97ed58&scoped=true&"
import script from "./NewUpdateLog.vue?vue&type=script&lang=js&"
export * from "./NewUpdateLog.vue?vue&type=script&lang=js&"
import style0 from "./NewUpdateLog.vue?vue&type=style&index=0&id=2d97ed58&lang=less&scoped=true&"
import style1 from "./NewUpdateLog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97ed58",
  null
  
)

export default component.exports